import React, { useMemo } from 'react';
import { Box, Card, Typography, Stack, Button } from '@mui/material';
import squareNotif from '../../assets/WidgetsIcon/square-notif.svg';
import timeIcon from '../../assets/WidgetsIcon/time.svg';
import { calculatePercentages, typeIconMatching } from './utils';

const IncidentTrends = ({ data }) => {
  const dayHoursPercentage = useMemo(
    () => calculatePercentages(data.dayHours),
    [data]
  );

  const typesPercentage = useMemo(
    () => calculatePercentages(data.types),
    [data]
  );

  return (
    <Card
      className="p-3"
      sx={{
        boxShadow: '0px 4px 4px 0px #0000000F',
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginLeft: 1,
            fontWeight: 700,
            lineHeight: '20px',
          }}
        >
          Incident Trends & Workload
        </Typography>
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        sx={{
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Box
          className="d-flex flex-column justify-content-between"
          sx={{
            px: 2,
            py: '12px',
            border: '1px solid #E1E1E1',
            borderRadius: '8px',
            minWidth: 'fit-content',
            minHeight: 200,
            height: 'stretch',
            flex: 1,
          }}
        >
          <Box
            className="d-flex"
            sx={{
              mb: '20px',
            }}
          >
            <img src={timeIcon} alt="noticeIcon" />{' '}
            <Typography
              variant="h6"
              sx={{
                marginLeft: 1,
                fontWeight: 700,
                lineHeight: '20px',
              }}
            >
              Time Range
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '16px',
            }}
          >
            <Box
              sx={{
                py: 2,
                minWidth: '130px',
                pb: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flex: 1,
                color: '#45856B',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Morning (6AM-12PM)
              </Typography>
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: 700,
                }}
              >
                {data.dayHours.Morning}
              </Typography>
              <Typography variant="body2">
                {dayHoursPercentage.Morning} incidents
              </Typography>
            </Box>

            <Box
              sx={{
                py: 2,
                minWidth: '130px',
                pb: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flex: 1,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Afternoon (12AM-6PM)
              </Typography>
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: 700,
                }}
              >
                {data.dayHours.Afternoon}
              </Typography>
              <Typography variant="body2">
                {dayHoursPercentage.Afternoon} incidents
              </Typography>
            </Box>

            <Box
              sx={{
                py: 2,
                minWidth: '130px',
                pb: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flex: 1,
                color: '#C71818',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Evening (6PM-12AM)
              </Typography>
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: 700,
                }}
              >
                {data.dayHours.Evening}
              </Typography>
              <Typography variant="body2">
                {dayHoursPercentage.Evening} incidents
              </Typography>
            </Box>

            <Box
              sx={{
                py: 2,
                minWidth: '130px',
                pb: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flex: 1,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Night (12PM-6AM)
              </Typography>
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: 700,
                }}
              >
                {data.dayHours.Night}
              </Typography>
              <Typography variant="body2">
                {dayHoursPercentage.Night} incidents
              </Typography>
            </Box>
          </Box>
        </Box>
        {/*<Box*/}
        {/*  className="d-flex flex-column justify-content-between"*/}
        {/*  sx={{*/}
        {/*    px: 2,*/}
        {/*    py: "12px",*/}
        {/*    border: "1px solid #E1E1E1",*/}
        {/*    borderRadius: "8px",*/}
        {/*    height: 200,*/}
        {/*    minWidth: 380,*/}
        {/*    flex: 1,*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Box className="d-flex align-items-center">*/}
        {/*    <img src={ava} alt="noticeIcon" />{" "}*/}
        {/*    <Typography*/}
        {/*      variant="h6"*/}
        {/*      sx={{*/}
        {/*        marginLeft: 1,*/}
        {/*        fontWeight: 700,*/}
        {/*        lineHeight: "20px",*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      Incidents by Shift*/}
        {/*    </Typography>*/}
        {/*    <Button variant="text" className="ms-auto" sx={{ color: "black", py: 0, lineHeight: "16px", fontSize: 16 }}>*/}
        {/*      See all shift*/}
        {/*    </Button>*/}
        {/*  </Box>*/}

        {/*  <Stack*/}
        {/*    direction="row"*/}
        {/*    spacing={2}*/}
        {/*    sx={{*/}
        {/*      justifyContent: "space-between",*/}
        {/*      alignItems: "center",*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Shift A*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        sx={{*/}
        {/*          fontSize: "18px",*/}
        {/*          fontWeight: 700,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        68*/}
        {/*      </Typography>*/}
        {/*      <Typography variant="body2">incidents</Typography>*/}
        {/*    </Box>*/}

        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Shift B*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        sx={{*/}
        {/*          fontSize: "18px",*/}
        {/*          fontWeight: 700,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        72*/}
        {/*      </Typography>*/}
        {/*      <Typography variant="body2">incidents</Typography>*/}
        {/*    </Box>*/}

        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Shift C*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        sx={{*/}
        {/*          fontSize: "18px",*/}
        {/*          fontWeight: 700,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        65*/}
        {/*      </Typography>*/}
        {/*      <Typography variant="body2">incidents</Typography>*/}
        {/*    </Box>*/}
        {/*  </Stack>*/}
        {/*</Box>*/}
        {Object.keys(data.types)?.length > 0 && (
          <Box
            className="d-flex flex-column justify-content-between"
            sx={{
              px: 2,
              py: '12px',
              border: '1px solid #E1E1E1',
              borderRadius: '8px',
              minWidth: 'fit-content',
              minHeight: 200,
              height: 'stretch',
              // maxWidth: 535,
              flex: 1,
            }}
          >
            <Box className="d-flex">
              <img src={squareNotif} alt="noticeIcon" />{' '}
              <Typography
                variant="h6"
                sx={{
                  marginLeft: 1,
                  fontWeight: 700,
                  lineHeight: '20px',
                }}
              >
                Incidents by Type
              </Typography>
            </Box>

            <Stack
              direction="row"
              spacing={6}
              useFlexGap
              sx={{
                flexWrap: 'wrap',
                mt: 3,
              }}
            >
              {Object.entries(data.types).map(([type, value], index) => (
                <Box
                  sx={{
                    minWidth: '100px',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    <img
                      src={typeIconMatching(type)}
                      alt="type icon"
                      style={{
                        width: '18px',
                      }}
                    />{' '}
                    {type}
                  </Typography>
                  <Typography>
                    {value}({typesPercentage[type]})
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>
        )}

        {/*<Box*/}
        {/*  className=" d-flex flex-column justify-content-between"*/}
        {/*  sx={{*/}
        {/*    px: 2,*/}
        {/*    py: "12px",*/}
        {/*    border: "1px solid #E1E1E1",*/}
        {/*    borderRadius: "8px",*/}
        {/*    height: 200,*/}
        {/*    minWidth: 840,*/}
        {/*    flex: 1,*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Box className="d-flex">*/}
        {/*    <img src={graphIcon} alt="noticeIcon" />{" "}*/}
        {/*    <Typography*/}
        {/*      variant="h6"*/}
        {/*      sx={{*/}
        {/*        marginLeft: 1,*/}
        {/*        fontWeight: 700,*/}
        {/*        lineHeight: "20px",*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      Top Responding Fire Stations*/}
        {/*    </Typography>*/}
        {/*  </Box>*/}

        {/*  <Stack*/}
        {/*    direction="row"*/}
        {/*    spacing={2}*/}
        {/*    sx={{*/}
        {/*      justifyContent: "space-between",*/}
        {/*      alignItems: "center",*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Fire Station #1*/}
        {/*      </Typography>*/}

        {/*      <Typography variant="body2">*/}
        {/*        <Typography*/}
        {/*          component="span"*/}
        {/*          sx={{*/}
        {/*            fontSize: "18px",*/}
        {/*            fontWeight: 700,*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          83{" "}*/}
        {/*        </Typography>*/}
        {/*        responses*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          color: "#00000091",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        51% of incidents*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}

        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Fire Station #1*/}
        {/*      </Typography>*/}

        {/*      <Typography variant="body2">*/}
        {/*        <Typography*/}
        {/*          component="span"*/}
        {/*          sx={{*/}
        {/*            fontSize: "18px",*/}
        {/*            fontWeight: 700,*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          83{" "}*/}
        {/*        </Typography>*/}
        {/*        responses*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          color: "#00000091",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        51% of incidents*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}
        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Fire Station #1*/}
        {/*      </Typography>*/}

        {/*      <Typography variant="body2">*/}
        {/*        <Typography*/}
        {/*          component="span"*/}
        {/*          sx={{*/}
        {/*            fontSize: "18px",*/}
        {/*            fontWeight: 700,*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          83{" "}*/}
        {/*        </Typography>*/}
        {/*        responses*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          color: "#00000091",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        51% of incidents*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}
        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Fire Station #1*/}
        {/*      </Typography>*/}

        {/*      <Typography variant="body2">*/}
        {/*        <Typography*/}
        {/*          component="span"*/}
        {/*          sx={{*/}
        {/*            fontSize: "18px",*/}
        {/*            fontWeight: 700,*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          83{" "}*/}
        {/*        </Typography>*/}
        {/*        responses*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          color: "#00000091",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        51% of incidents*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}
        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 2,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Fire Station #1*/}
        {/*      </Typography>*/}

        {/*      <Typography variant="body2">*/}
        {/*        <Typography*/}
        {/*          component="span"*/}
        {/*          sx={{*/}
        {/*            fontSize: "18px",*/}
        {/*            fontWeight: 700,*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          83{" "}*/}
        {/*        </Typography>*/}
        {/*        responses*/}
        {/*      </Typography>*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          color: "#00000091",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        51% of incidents*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}
        {/*  </Stack>*/}
        {/*</Box>*/}

        {/*<Box*/}
        {/*  className="d-flex flex-column justify-content-between"*/}
        {/*  sx={{*/}
        {/*    px: 2,*/}
        {/*    py: "12px",*/}
        {/*    border: "1px solid #E1E1E1",*/}
        {/*    borderRadius: "8px",*/}
        {/*    height: 200,*/}
        {/*    minWidth: 430,*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <Box className="d-flex">*/}
        {/*    <img src={carIcon} alt="noticeIcon" />{" "}*/}
        {/*    <Typography*/}
        {/*      variant="h6"*/}
        {/*      sx={{*/}
        {/*        marginLeft: 1,*/}
        {/*        fontWeight: 700,*/}
        {/*        lineHeight: "20px",*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      Units Deployed*/}
        {/*    </Typography>*/}
        {/*  </Box>*/}

        {/*  <Typography*/}
        {/*    sx={{*/}
        {/*      fontWeight: 600,*/}
        {/*      fontSize: 36,*/}
        {/*      color: "#C71818",*/}
        {/*      mt: 3,*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    40*/}
        {/*    <Typography*/}
        {/*      component="span"*/}
        {/*      sx={{*/}
        {/*        fontSize: 36,*/}
        {/*        fontWeight: 400,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      /42*/}
        {/*    </Typography>*/}
        {/*  </Typography>*/}

        {/*  <Stack*/}
        {/*    direction="row"*/}
        {/*    spacing={2}*/}
        {/*    sx={{*/}
        {/*      justifyContent: "space-between",*/}
        {/*      alignItems: "center",*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 1,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Fire Engines*/}
        {/*      </Typography>*/}

        {/*      <Typography*/}
        {/*        component="span"*/}
        {/*        sx={{*/}
        {/*          fontSize: "18px",*/}
        {/*          fontWeight: 700,*/}
        {/*          color: "#45856B",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        8/15*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}

        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 1,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Ambulances*/}
        {/*      </Typography>*/}

        {/*      <Typography*/}
        {/*        component="span"*/}
        {/*        sx={{*/}
        {/*          fontSize: "18px",*/}
        {/*          fontWeight: 700,*/}
        {/*          color: "#C71818",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        18/18*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}

        {/*    <Box*/}
        {/*      sx={{*/}
        {/*        py: 2,*/}
        {/*        minWidth: "130px",*/}
        {/*        pb: 0,*/}
        {/*        display: "flex",*/}
        {/*        flexDirection: "column",*/}
        {/*        justifyContent: "space-between",*/}
        {/*        flex: 1,*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Typography*/}
        {/*        variant="body2"*/}
        {/*        sx={{*/}
        {/*          fontWeight: 600,*/}
        {/*          mb: 1,*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Special Units*/}
        {/*      </Typography>*/}

        {/*      <Typography*/}
        {/*        component="span"*/}
        {/*        sx={{*/}
        {/*          fontSize: "18px",*/}
        {/*          fontWeight: 700,*/}
        {/*          color: "#45856B",*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        5/20*/}
        {/*      </Typography>*/}
        {/*    </Box>*/}
        {/*  </Stack>*/}
        {/*</Box>*/}
      </Stack>
    </Card>
  );
};

export default IncidentTrends;
